import Vue from 'vue'

import './elementUI'
import './echarts'
import './vuescroll'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
